import { jsx as _jsx } from "react/jsx-runtime";
import { List, ListItem } from '@coolblue-development/freddy';
import { Children } from 'react';
import { suggestionListItemStyles } from './Typeahead.styles';
const Suggestion = ({ children }) => (_jsx(List, { marker: "none", m: 0, children: Children.map(children, (child, id) => (_jsx(ListItem, { py: 200, px: 400, sx: suggestionListItemStyles, children: child }, id))) }));
export { Suggestion };
//# sourceMappingURL=Suggestion.js.map